import { type ClassValue, clsx } from 'clsx';

import { sonaTwMerge } from './tw-merge';

export function sonaHlm(...inputs: ClassValue[]) {
    return sonaTwMerge(clsx(inputs));
}
